/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';

/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import MultiSelectForm from 'components/Common/ElementInForm/MultiSelectForm';




am4core.addLicense("CH208466903");
am4core.useTheme(am4themes_animated);


const BASummaryChart = (props) => {

    const { name, data, nID, divPie, divBar, IsExport,optionAll,onLoadGraphGetDataBA,IsSearch } = props
    const [optionSelect, setOptionSelect] = useState([] as any);


    const schema = yup.object().shape({
        oTypeyear: yupFormSchemas.object(`type display`, { required: false }),
    });

    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError"
    })

    useEffect(() => {

        if (data != null) {
            onRenderGraphPie(data.lstdataPie)
            GraphStackClusteredBar(data.lstdataXY)
        }
    }, [data])

    useEffect(() => {
        form.setValue("oTypeyear", { value: "9999", label: "ทั้งหมด" })
    }, [IsSearch])
    

    const onRenderGraphPie = (lstdata) => {


        let chart = am4core.create(divPie, am4charts.PieChart);

        // Add data
        chart.data = lstdata;

        // Add and configure Series
        let pieSeries = chart.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = "value";
        pieSeries.dataFields.category = "name";
        var colorSet = new am4core.ColorSet();
        colorSet.list = [chart.colors.getIndex(0), chart.colors.getIndex(3), chart.colors.getIndex(6), chart.colors.getIndex(9)].map(color => {
            return am4core.color(color);
        });
        pieSeries.colors = colorSet;
        // pieSeries.ticks.template.disabled = true;
        // pieSeries.labels.template.disabled = true;
        pieSeries.slices.template.stroke = am4core.color("#fff");
        pieSeries.slices.template.strokeOpacity = 1;
        pieSeries.legendSettings.labelText = "{category}";
        pieSeries.labels.template.fontSize = 12;
        pieSeries.labels.template.paddingTop = 0;
        pieSeries.labels.template.paddingBottom = 0;
        pieSeries.labels.template.text = "{value}, {sPercent}%";
        pieSeries.labels.template.maxWidth = 150;
        pieSeries.labels.template.wrap = true;
        pieSeries.alignLabels = false;
        pieSeries.slices.template.tooltipText = "{category}: {value}, {sPercent}%";

        // This creates initial animation
        pieSeries.hiddenState.properties.opacity = 1;
        pieSeries.hiddenState.properties.endAngle = -90;
        pieSeries.hiddenState.properties.startAngle = -90;

        chart.hiddenState.properties.radius = am4core.percent(0);

        chart.legend = new am4charts.Legend();
        chart.legend.useDefaultMarker = true;
        chart.legend.labels.template.text = "{name}[/]";
        chart.legend.valueLabels.template.disabled = true;

        chart.legend.verticalCenter = "middle";

        var marker = chart.legend.markers.template.children.getIndex(0) as any;

        marker.cornerRadius(12, 12, 12, 12);
        marker.strokeWidth = 2;
        marker.strokeOpacity = 1;
        marker.stroke = am4core.color("#ccc");

        if (IsExport == true) {
            setTimeout(() => {
                chart.exporting.getImage("png").then((data) => {
                    let obj = {
                        id: nID,
                        nOrder: 1,
                        sDesc: divPie,
                        sName: "",
                        idDiv: nID,
                        imgBase64: data
                    }
                    props.exportImg && props.exportImg(obj);
                });
            }, 2000);
        }

    }


    const GraphStackClusteredBar = (lstdata) => {
        let chart = am4core.create(divBar, am4charts.XYChart);
        // Add data
        let data = lstdata.lstdata != null ? lstdata.lstdata : []
        let nCountList = data.length;
        chart.data = data;

        // Create axes
        let yAxis = chart.yAxes.push(new am4charts.CategoryAxis()) as any;
        yAxis.dataFields.category = "vocService";
        yAxis.renderer.grid.template.location = 0;
        yAxis.renderer.labels.template.fontSize = 10;
        yAxis.renderer.labels.template.verticalCenter = 'middle';
        yAxis.renderer.labels.template.horizontalCenter = "left";
        yAxis.renderer.maxLabelPosition = 1;
        yAxis.renderer.minGridDistance = 40;
        // yAxis.renderer.labels.template.propertyFields.html = "vocService";
        yAxis.renderer.labels.template.wrap = true;
        yAxis.renderer.labels.template.width = 100;
        yAxis.renderer.labels.template.tooltipText = "{sServiceName}";
        yAxis.renderer.labels.template.adapter.add("textOutput", function(text) {
            return (text || "").replace("_1", "").replace("_2", "").replace("_3", "").replace("_4", "");
          });

        let xAxis = chart.xAxes.push(new am4charts.ValueAxis());
        xAxis.min = 0;
        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries()) as any;
        series.dataFields.valueX = "value";
        series.dataFields.categoryY = "vocService";
        series.columns.template.tooltipText = "{sServiceName}: [bold]{valueX}[/]";
        series.columns.template.strokeWidth = 0;
        series.columns.template.maxHeight = 50;
        series.columns.template.adapter.add("fill", function (fill, target) {
            if (target.dataItem) {
                let sFill = null as any;
                switch (target.dataItem.dataContext.type) {
                    case "คุณภาพ":
                        sFill = chart.colors.getIndex(0);
                        break;
                    case "ปริมาณ":
                        sFill = chart.colors.getIndex(3);
                        break;
                    case "บริการก่อนการขาย":
                        sFill = chart.colors.getIndex(6);
                        break;
                    case "บริการหลังการขาย":
                        sFill = chart.colors.getIndex(9);
                        break;
                }
                fill = sFill;
            }
            return fill;
        });

        // Add ranges
        function addRange(label, start, end, color,nCountService) {
            
            if (start != "") {
                let range = yAxis.axisRanges.create();
                range.category = start;
                range.endCategory = end;
                range.label.text = label;
                range.label.fill = am4core.color("#000000");
                range.label.disabled = false;
                range.label.dx = -100;
                range.label.dy = nCountList == 1 ? 265 : 100;
                range.label.rotation = 270;
                range.label.fontWeight = "bold";
                range.label.fontSize = 10;
                range.label.verticalCenter  = "middle"
                range.label.horizontalCenter = "left"
                range.label.inside = false;

                range.locations.category = 1;
            }

        }

        if (lstdata.lstCrete != null && lstdata.lstCrete.length > 0) {
            (lstdata.lstCrete).forEach(element => {
                // if (element.label == "บริการก่อนการขาย") {
                //     element.label = "บริการก่อน\nการขาย"
                // }
                // else if (element.label == "บริการหลังการขาย") {
                //     element.label = "บริการหลัง\nการขาย"
                // }
                addRange(element.label, element.Start, element.End, element.color,element.nCountService);
            });
        }
        if (IsExport == true) {
            setTimeout(() => {
                chart.exporting.getImage("png").then((data) => {
                    let obj = {
                        id: nID,
                        nOrder: 2,
                        sDesc: divPie,
                        sName: "",
                        idDiv: nID,
                        imgBase64: data
                    }
                    props.exportImg && props.exportImg(obj);
                });
            }, 5000);
        }
    }

    return (
        <>
            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="start" >
                <Grid item xs={12}>
                    <Grid container spacing={1} direction="row" justifyContent="space-between" alignItems="center" >
                        <Grid item xs={12} sm={'auto'}>
                            <Typography>
                                {name}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                            <FormProvider {...form}>
                                <AutoCompleteSelect
                                    name="oTypeyear"
                                    options={optionAll?.optionAllMonthYear || []}
                                    required={false}
                                    disableClearable={true}
                                    IsRadius={true}
                                    onChange={(oValue) => { 
                                        if(oValue)
                                        {
                                            let nBA = name == "CMM" ? 1 : name == "GSM" ? 2 : name == "NGR" ? 3 : 4;
                                            let param ={ 
                                                "valueSearch" : oValue?.value ?? null,
                                                "nBA" : nBA
                                            }
                                            onLoadGraphGetDataBA(param,nBA)
                                        }
                                    }}
                                />
                            </FormProvider>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <div id={name}>
                        <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                            <Grid item xs={12} md={5}>
                                <div id={divPie} style={{ width: "80%", height: "400px", margin: 'auto' }}></div>
                            </Grid>
                            <Grid item xs={12} md={7}>
                                <div id={divBar} style={{ width: "100%", height: "550px" }}></div>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
            </Grid>
        </>
    )
}

export default BASummaryChart